import React, { FC, useState } from 'react';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import './Header.scss';
import ROUTES from '../../../library/constants/routeConstants';
import Sidebar from '../Sidebar/Sidebar';
import { Help } from '@mui/icons-material';
import PasswordChangeModal from '../../../library/components/PasswordChangeModal/PasswordChangeModal';
import { SETTINGS_TYPES } from '../../../library/constants/settingsTypes';
import { useAppSelector } from '../../hooks/hooks';
import { selectIsAdmin } from '../../slices/authSlice';
import { assetMap } from '../../../library/util/assetMap';
import styles from '../../../assets/styles/variables.module.scss';
import { Tooltip } from '@mui/material';

const Header: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const [menuOpen, setMenuOpen] = useState(false)
    const [passwordModalOpen, setPasswordModalOpen] = useState(false);
    const isAdmin = useAppSelector(selectIsAdmin);

    const env = process.env.REACT_APP_SKIN_NAME || '';
    
    const handleShowMenu = () => {
        setMenuOpen(true);
    }

    const handleHelpClick = () => {
        window.open('https://partsol.zendesk.com', '_blank')
    }

    const handleSettingsClick = () => {
        const type = SETTINGS_TYPES.GRAPH
        navigate(generatePath(ROUTES.SETTINGS, { type }), { state: { from: location.pathname } });
    }

    return <div className="header-wrapper">
        <PasswordChangeModal open={passwordModalOpen} onClose={() => setPasswordModalOpen(false)} />
        <div className="header-section left">
            {/* <MenuIcon /> */}
            <div className="app-name" onClick={() => navigate(ROUTES.DASHBOARD)}>
                {env === 'jaq' ? (
                    <img src={assetMap('headerLogo')} />
                ) : env === 'atai' ? (
                    <img style={{ width: '80px' }} src={assetMap('headerLogo')} />
                ) : (
                    <span>PSI Checkmate&#8482;</span>
                )}
            </div>
        </div>
        <div className="header-section right">
            {/* <Help fontSize="inherit" onClick={handleHelpClick} /> */}
            {/* <NotificationsIcon fontSize="inherit"/> */}
            {location.pathname === ROUTES.ATAI ? 
                <Tooltip title="ATAI">
                    <svg 
                        width="30" 
                        height="27" 
                        viewBox="0 0 30 27"
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ 
                        width: 90,
                        background: styles.color_grid_background,
                        borderRadius: '15px 15px 0 0',
                        overflow: 'hidden',
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        height: '25px'
                    }} 
                    onClick={() => navigate(ROUTES.ATAI)}
                >
                    <path d="M22.6881 6.73148C22.4193 6.54093 21.9697 6.99068 20.463 6.99068C18.9563 6.99068 10.7067 6.99068 9.22959 6.99068C7.75244 6.99068 7.27275 6.52913 7.00448 6.73148C6.73621 6.93383 8.2916 9.30536 9.32626 9.30536L10.1896 9.35447L8.80392 12.8218L11.7121 12.8709L12.9412 9.35447H13.1085C13.1085 9.35447 13.7667 24.7209 13.8116 25.3549C13.8565 25.9889 14.8463 26.3889 14.8463 26.3889C14.8463 26.3889 15.8065 25.9889 15.881 25.3549C15.9554 24.7209 16.5841 9.35447 16.5841 9.35447H16.7514L18.01 12.8709L20.9183 12.8218L19.503 9.35447L20.3664 9.30536C21.401 9.30536 22.9569 6.92203 22.6881 6.73148Z" fill="#AE8735"/>
                    <path d="M24.8973 12.4599C24.6626 12.2515 24.0203 12.9137 22.7688 12.9646C21.5174 13.0155 16.5938 13.0628 16.5938 13.0628L16.5445 15.0829H18.9849C18.9849 15.0829 21.0838 19.153 23.3305 21.0223C26.6685 23.7996 29.3611 22.4497 29.3611 22.1077C29.3611 21.7656 27.2532 21.4701 25.6273 19.8722C24.0944 18.3656 21.9697 15.0829 21.9697 15.0829L22.6722 15.0337C23.7068 15.0337 25.1319 12.6682 24.8973 12.4599Z" fill="#AE8735"/>
                    <path d="M4.8249 12.4599C5.04942 12.2753 5.65358 12.9137 6.95334 12.9646C8.25309 13.0155 13.1284 13.0628 13.1284 13.0628L13.1845 15.0829H10.7372C10.7372 15.0829 8.63835 19.153 6.39167 21.0223C3.05363 23.7996 0.361083 22.4742 0.361084 22.1077C0.361085 21.7411 2.46898 21.4701 4.09488 19.8722C5.6278 18.3656 7.75244 15.0829 7.75244 15.0829L7.05001 15.0337C6.01535 15.0337 4.60038 12.6444 4.8249 12.4599Z" fill="#AE8735"/>
                        <path d="M17.5194 3.31227C17.5194 4.80409 16.3292 6.01345 14.8611 6.01345C13.3929 6.01345 12.2028 4.80409 12.2028 3.31227C12.2028 1.82044 13.3929 0.611084 14.8611 0.611084C16.3292 0.611084 17.5194 1.82044 17.5194 3.31227Z" fill="#AE8735"/>
                    </svg>
                </Tooltip> : 
                <Tooltip title="ATAI">
                    <svg 
                        width="42" 
                        height="39" 
                        viewBox="0 0 42 39" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        className="atai-icon atai-gradient"
                        onClick={() => navigate(ROUTES.ATAI)}
                    >
                        <title>ATAI</title>
                        <g filter="url(#filter0_d_1388_2969)">
                            <path d="M28.6881 11.7315C28.4193 11.5409 27.9697 11.9907 26.463 11.9907C24.9563 11.9907 16.7067 11.9907 15.2296 11.9907C13.7524 11.9907 13.2728 11.5291 13.0045 11.7315C12.7362 11.9338 14.2916 14.3054 15.3263 14.3054L16.1896 14.3545L14.8039 17.8218L17.7121 17.8709L18.9412 14.3545H19.1085C19.1085 14.3545 19.7667 29.7209 19.8116 30.3549C19.8565 30.9889 20.8463 31.3889 20.8463 31.3889C20.8463 31.3889 21.8065 30.9889 21.881 30.3549C21.9554 29.7209 22.5841 14.3545 22.5841 14.3545H22.7514L24.01 17.8709L26.9183 17.8218L25.503 14.3545L26.3664 14.3054C27.401 14.3054 28.9569 11.922 28.6881 11.7315Z" fill="#FBFBFB"/>
                            <path d="M30.8973 17.4599C30.6626 17.2515 30.0203 17.9137 28.7688 17.9646C27.5174 18.0155 22.5938 18.0628 22.5938 18.0628L22.5445 20.0829H24.9849C24.9849 20.0829 27.0838 24.153 29.3305 26.0223C32.6685 28.7996 35.3611 27.4497 35.3611 27.1077C35.3611 26.7656 33.2532 26.4701 31.6273 24.8722C30.0944 23.3656 27.9697 20.0829 27.9697 20.0829L28.6722 20.0337C29.7068 20.0337 31.1319 17.6682 30.8973 17.4599Z" fill="#FBFBFB"/>
                            <path d="M10.8249 17.4599C11.0494 17.2753 11.6536 17.9137 12.9533 17.9646C14.2531 18.0155 19.1284 18.0628 19.1284 18.0628L19.1845 20.0829H16.7372C16.7372 20.0829 14.6384 24.153 12.3917 26.0223C9.05363 28.7996 6.36108 27.4742 6.36108 27.1077C6.36109 26.7411 8.46898 26.4701 10.0949 24.8722C11.6278 23.3656 13.7524 20.0829 13.7524 20.0829L13.05 20.0337C12.0153 20.0337 10.6004 17.6444 10.8249 17.4599Z" fill="#FBFBFB"/>
                            <path d="M23.5194 8.31227C23.5194 9.80409 22.3292 11.0135 20.8611 11.0135C19.3929 11.0135 18.2028 9.80409 18.2028 8.31227C18.2028 6.82044 19.3929 5.61108 20.8611 5.61108C22.3292 5.61108 23.5194 6.82044 23.5194 8.31227Z" fill="#FBFBFB"/>
                        </g>
                        <defs>
                            <filter id="filter0_d_1388_2969" x="0.361084" y="0.611084" width="41" height="37.7778" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                <feOffset dy="1"/>
                                <feGaussianBlur stdDeviation="3"/>
                                <feComposite in2="hardAlpha" operator="out"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1388_2969"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1388_2969" result="shape"/>
                            </filter>
                        </defs>
                    </svg>
                </Tooltip>
            }
            
            
            <Tooltip title="Settings">
                <SettingsIcon fontSize="inherit" onClick={handleSettingsClick} />
            </Tooltip>
            <Tooltip title="User">
                <AccountCircleIcon className="user-icon" fontSize="inherit" onClick={handleShowMenu} />
            </Tooltip>
        </div>
        <Sidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} setPasswordModalOpen={setPasswordModalOpen} isAdmin={isAdmin} />
        
    </div>;
}

export default Header;